import type { PaymentTransaction } from 'api/payments.ts';
import classnames from 'classnames';
import { TransactionsEmptyState } from 'components/EmptyStates';
import { type FC, Fragment } from 'react';
import { TransactionsItem } from './TransactionsItem';
import { TransactionsTableHeader } from './TransactionsTableHeader';

import styles from './TransactionsTable.module.scss';

type TransactionTableProps = {
  transactions: PaymentTransaction[];
  isLoaded: boolean;
};

const TransactionsTable: FC<TransactionTableProps> = ({
  transactions,
  isLoaded,
}) => {
  return (
    <Fragment>
      {transactions.length > 0 && (
        <div className={styles['transactions-table-wrapper']}>
          <TransactionsTableHeader />
          <div className={classnames(styles['transactions-table-body'])}>
            {transactions.map((transaction) => (
              <TransactionsItem
                key={transaction.id}
                transaction={transaction}
              />
            ))}
          </div>
        </div>
      )}
      {!transactions.length && isLoaded && <TransactionsEmptyState />}
    </Fragment>
  );
};

export default TransactionsTable;
